import React, { Component } from 'react';
import './Spinner.css';

class Spinner extends Component {
  render() {
    return (
      <div className={'store-app-spinner'}>
        <svg
          viewBox="0 0 100 100"
        >
          <circle opacity=".19" cx="31.19" cy="24.11" r="5" />
          <circle opacity=".36" cx="19.57" cy="40.11" r="5" />
          <circle opacity=".51" cx="19.57" cy="59.89" r="5" />
          <circle opacity=".64" cx="31.19" cy="75.89" r="5" />
          <circle opacity=".75" cx="50" cy="82" r="5" />
          <circle opacity=".84" cx="68.81" cy="75.89" r="5" />
          <circle opacity=".91" cx="80.43" cy="59.89" r="5" />
          <circle opacity=".96" cx="80.43" cy="40.11" r="5" />
          <circle opacity=".99" cx="68.81" cy="24.11" r="5" />

          <circle cx="50" cy="18" r="5" />
        </svg>
      </div>
    )
  }
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js